<template>
  <q-btn-group
    v-bind="$attrs"
    flat
    class="q-pa-xs bg-responsive-grey-1"
  >
    <q-btn
      v-for="(button, index) in buttons"
      :key="index"
      class="rounded-borders q-px-sm"
      :class="button.class"
      style="min-width: fit-content;"
      :label="button.label"
      no-caps
      :color="button.color"
      :text-color="button.textColor"
      :disable="loading"
      @click="$emit('select-tab', button.value)"
    />
  </q-btn-group>
</template>
<script>

export default {
  name: 'TabToggleButton',
  props: {
    buttons: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select-tab']
}
</script>
<style scoped>
  .text-weight-regular {
      font-weight: 400 !important;
  }
</style>
